import React from "react";
import { useNavigate } from "react-router-dom";

/*
  MODULE GUARD — mode ke darwaze par ek saaf jawab.

  ─────────────────────────────────────────────────────────────────────────────
  KYUN BANA

  T11.5 me har module ke GET endpoints par gate laga. Backend ab sahi rokta hai.
  Par frontend par koi rok nahi thi, to end-to-end test me ye nikla:

      ZZTH_opd (sirf OPD module) -> /hrms/dashboard
      backend:  Hrms/dashboard, widgets, setup-health  ->  403
      screen :  HRMS dashboard poora render, har jagah 0

  Data leak nahi hua — par user ko lagta hai "koi employee hi nahi hai".
  Wahi /ward/dashboard par bhi: "0 Admitted".

  Ye jhooth khatarnak hai. Nurse ward khole aur "0 Admitted" dekhe to wo maan
  legi ki ward khaali hai. Isliye darwaze par hi saaf jawab dena zaroori hai.

  ─────────────────────────────────────────────────────────────────────────────
  JAANCH KAISE HOTI HAI

  1. `isHospitalAdmin` — Tier 1 ko sab kuch. Ye zaroori hai kyunki hospital admin
     ka adhikar FLAG se aata hai; uske paas har module ki `UserRoles` row ho ye
     zaroori nahi. Iske bina guard admin ko hi rok deta.

  2. `allowedModules` — login response se aata hai aur backend use ASLI adhikar
     se banata hai (`AuthController`: Add/Edit/Delete me se koi 'Y' ho tabhi wo
     module list me aata hai). Isliye ispar bharosa kiya ja sakta hai.

  ⚠️ Ye SIRF UI ka aaram hai, suraksha nahi. Asli rok backend ke gate hain.
     Koi sessionStorage badal kar andar aa bhi jaye to har API 403 hi degi.
*/

export function hasModule(name) {
  try {
    if (sessionStorage.getItem("isHospitalAdmin") === "1") return true;
    const raw = sessionStorage.getItem("allowedModules");
    if (!raw) return false;
    const mods = JSON.parse(raw).map((m) => String(m).trim().toUpperCase());

    const want = String(name).trim().toUpperCase();
    if (mods.includes(want)) return true;

    // ── HMS wale ko kahan andar aane dena hai ───────────────────────────────
    //
    // ⚠️ Ye jaanch pehle THI HI NAHI, aur usse teen jagah ki soch alag ho gayi:
    //
    //     backend  : Pharmacy ka gate `CanView(1) || CanView(3)` hai
    //                Ward ka `CanView(1) || CanView(15)` -- dono HMS ko lene dete hain
    //     Sidebar  : `hasAccess` me HMS par `return true` -- menu DIKHTA hai
    //     ye guard : HMS ko maanta hi nahi tha -- andar jaate hi ROK
    //
    // Live par pakda gaya: `DevUser` ke paas HMS=YYY tha. Use Pharmacy ka menu
    // dikhta tha, par click karte hi "You do not have permission" -- jabki
    // backend uska kaam maan raha tha. Wahi Ward par bhi.
    //
    // ⚠️ Ye soochi backend se MEL khani chahiye -- na zyada, na kam.
    //
    //    Backend me niyam ek hi jagah hai: `PermissionService.HmsBhiKholta`
    //    (aur baaki module ke controller me `|| CanView(1)`).
    //
    //    Yahan zyada likh diya  -> user andar chala jayega par har API 403 degi,
    //                              aur screen par har jagah 0 dikhega. Wahi
    //                              jhooth jise rokne ke liye ye guard bana tha.
    //    Yahan kam likh diya    -> backend allow karega par screen rok degi.
    //                              (29 Aug ko live par yahi hua tha -- HMS wale
    //                               ko Pharmacy ka menu dikhta tha par andar
    //                               jaate hi rok lagti thi.)
    //
    // HRMS 29 Aug 2026 ko joda gaya -- user ka faisla. Uske saath backend me
    // `HmsBhiKholta` me bhi 16 jodna zaroori tha; dono saath badalte hain.
    const HMS_KHOLTA_HAI = ["HMS", "PHARMACY", "IPD WARD", "INVENTORY", "HRMS"];

    if ((mods.includes("HMS") || mods.includes("ADMIN")) && HMS_KHOLTA_HAI.includes(want)) {
      return true;
    }

    return false;
  } catch {
    // sessionStorage padha na ja sake to rok mat lagao — backend waise bhi rokta hai,
    // aur yahan galat rok lagana asli kaam rok deti hai.
    return true;
  }
}

const ModuleGuard = ({ module: moduleName, label, children }) => {
  const navigate = useNavigate();

  if (hasModule(moduleName)) return children;

  return (
    <div className="mg-wrap">
      <div className="mg-box">
        <i className="bi bi-shield-lock mg-ic"></i>
        <h4 className="mg-ttl">{label || moduleName} access required</h4>
        <p className="mg-txt">
          You do not have permission to open the {label || moduleName} module.
          Ask your hospital admin to give you access.
        </p>
        <button className="mg-btn" onClick={() => navigate("/dashboard")}>
          Back to dashboard
        </button>
      </div>

      <style>{`
        .mg-wrap { display:flex; align-items:center; justify-content:center; min-height:80vh; padding:2rem; }
        .mg-box { text-align:center; max-width:460px; }
        .mg-ic { font-size:3rem; color:#94a3b8; }
        .mg-ttl { margin:14px 0 8px; color:#0f172a; font-weight:700; }
        .mg-txt { color:#64748b; font-size:.9rem; line-height:1.6; margin-bottom:20px; }
        .mg-btn { padding:9px 20px; border:none; border-radius:8px; background:#0088cc; color:#fff; font-weight:600; cursor:pointer; }
      `}</style>
    </div>
  );
};

export default ModuleGuard;
